/******************************************************************************************
 *	String Encoder
 *******************************************************************************************
 *
 * Converts between UTF-8, UTF-16LE, UTF-16BE.
 *
 */
(function() {
  

  angular.module('rcServices.utfEncoder', []).factory('UtfEncoder', function(_) {
    /*
      * Modified version of original source here: http://jsfiddle.net/kimiliini/HM4rW/light/
      */
    function DataEnc(a) {
      this.config(a);
    }

    /*
      * http://www.iana.org/assignments/character-sets/character-sets.xhtml
      */
    DataEnc._enctype = {
      u8: ['u8', 'utf8'],
      // RFC-2781,Big endian should be presumed if none given
      u16be: ['u16', 'u16be', 'utf16', 'utf16be', 'ucs2', 'ucs2be'],
      u16le: ['u16le', 'utf16le', 'ucs2le']
    };
    DataEnc._BOM = {
      none: '',
      'UTF-8': '%ef%bb%bf', // Discouraged
      'UTF-16BE': '%fe%ff',
      'UTF-16LE': '%ff%fe'
    };
    DataEnc.prototype = {
      // Basic setup
      config: function(a) {
        var opt = {
          charset: 'u8',
          mime: 'text/csv',
          base64: 0,
          bom: 0
        };
        var p;
        a = a || {};
        for (p in opt) {
          if (opt.hasOwnProperty(p)) {
            this[p] = a.hasOwnProperty(p) ? a[p] : opt[p];
          }
        }
        this.buf = '';
        this.lead = '';
        this.__intro();
        return this;
      },
      // Create lead based on config
      // [<MIME-type>][;charset=<encoding>][;base64],<data>
      __intro: function() {
        var g = [],
          c = this.charset || '',
          b = 'none';
        if (this.mime && this.mime !== '') {
          g.push(this.mime);
        }
        if (c !== '') {
          // toLower is not chain-able
          c = _.toLower(_.replace(c, /[-\s]/g, ''));
          if (_.includes(DataEnc._enctype.u8, c)) {
            c = 'UTF-8';
            if (this.bom) {
              b = c;
            }
            this.enc = this.utf8;
          } else if (_.includes(DataEnc._enctype.u16be, c)) {
            c = 'UTF-16BE';
            if (this.bom) {
              b = c;
            }
            this.enc = this.utf16be;
          } else if (_.includes(DataEnc._enctype.u16le, c)) {
            c = 'UTF-16LE';
            if (this.bom) {
              b = c;
            }
            this.enc = this.utf16le;
          } else {
            if (c === 'copy') {
              c = '';
            }
            this.enc = this.copy;
          }
        }
        if (c !== '') {
          g.push('charset=' + c);
        }
        if (this.base64) {
          g.push('base64');
        }
        this.lead = g.join(';');
        this.buf += DataEnc._BOM[b]; //Prepend BOM
        return this;
      },
      // Get Data URI
      getDataUri: function() {
        return 'data:' + this.lead + ',' + this.buf;
      },
      // UTF-16BE
      utf16be: function(t) {
        // U+0500 => %05%00
        var i,
          c,
          buf = [];
        for (i = 0; i < t.length; ++i) {
          if ((c = t.charCodeAt(i)) > 0xff) {
            buf.push(('0' + (c >> 0x08).toString(16)).substr(-2));
            buf.push(('0' + (c & 0xff).toString(16)).substr(-2));
          } else {
            buf.push('00');
            buf.push(('0' + (c & 0xff).toString(16)).substr(-2));
          }
        }
        this.buf += '%' + buf.join('%');
        // Note the hex array is returned, not string with '%'
        // Might be useful if one want to loop over the data.
        return buf;
      },
      // UTF-16LE
      utf16le: function(t) {
        // U+0500 => %00%05
        var i,
          c,
          buf = [];
        for (i = 0; i < t.length; ++i) {
          if ((c = t.charCodeAt(i)) > 0xff) {
            buf.push(('0' + (c & 0xff).toString(16)).substr(-2));
            buf.push(('0' + (c >> 0x08).toString(16)).substr(-2));
          } else {
            buf.push(('0' + (c & 0xff).toString(16)).substr(-2));
            buf.push('00');
          }
        }
        this.buf += '%' + buf.join('%');
        // Note the hex array is returned, not string with '%'
        // Might be useful if one want to loop over the data.
        return buf;
      },
      // UTF-8
      utf8: function(t) {
        this.buf += encodeURIComponent(t);
        return this;
      },
      // Direct copy
      copy: function(t) {
        this.buf += t;
        return this;
      }
    };

    return DataEnc;
  });
})();
